export enum TimeSelectionMode {
  DaysOnly = 0,
  DaysAndTime = 1
}

export const TimeSelectionModeOptions = [
  { value: TimeSelectionMode.DaysOnly, label: 'core.time_selection.days_only' },
  { value: TimeSelectionMode.DaysAndTime, label: 'core.time_selection.days_and_time' }
];
